import { type Common } from './common.js';
import {
  type FindAllOptions,
  type InsuranceInformation,
  type PredictedPlanResult,
} from './models/patient/insuranceInformation.js';

export class API {
  common: Common;
  baseEndpoint = '/patient-insurance-information';

  constructor(common: Common) {
    this.common = common;
  }

  async findAllByEhrInformationId(
    ehrInformationId: string,
    query?: FindAllOptions
  ): Promise<InsuranceInformation[]> {
    const url = this.common.constructPath(
      `/ehr-information/${ehrInformationId}/insurance-information`,
      query
    );
    return await this.common.getJSON(url);
  }

  async findAllPlanNamesByPartial(partialPlanName: string): Promise<string[]> {
    const url = this.common.constructPath(`${this.baseEndpoint}/searchPlanNames`, {
      partialPlanName,
    });
    return await this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<InsuranceInformation> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.getJSON(url);
  }

  async update(id: string, values: Partial<InsuranceInformation>): Promise<InsuranceInformation> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.patchJSON(url, values);
  }

  async debugPlanSelection(
    patientInsuranceInformationId: string
  ): Promise<PredictedPlanResult | undefined> {
    const url = this.common.constructPath(
      `${this.baseEndpoint}/${patientInsuranceInformationId}/plan`
    );
    return await this.common.getJSON(url);
  }
}
